import { useCurrentUserLocale } from "@radarly/core/user/use-cases";
import { tr } from "@radarly/i18n";
import { hasValidConfigurationTemplate } from "@radarly/models/insight-pages/wizard/configuration";
import { WizardTemplate } from "@radarly/models/insight-pages/wizard/model";
import { WizardConfiguration } from "@radarly/models/insight-pages/wizard/model/configuration";

export function useWizardPreviewValidity(
  template: WizardTemplate,
  configuration: WizardConfiguration
) {
  const locale = useCurrentUserLocale();
  return {
    isValid: hasValidConfigurationTemplate(template, configuration),
    labels: {
      title: tr(locale, "lorem"),
    },
  };
}
